module.exports = __webpack_public_path__ + "img/MDI-account-eye.ea7e0447.svg";